import { changeLocale } from "../redux/actions/loginactioncreators";
import LanguageIcon from "@material-ui/icons/Language";
import { useSelector, useDispatch } from "react-redux";
import { Menu, MenuItem, Typography, Hidden } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import locales from "../i18n/locales";
import React, { useState, useCallback } from "react";
import SterlingButton from "@sterling-react/button";

export const LocalizationSelect = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  const locale = useSelector(state => state.intl.locale || state.intl.defaultLocale);
  const allowedLocales = useSelector(state => state.intl.allowedLocales);

  const bespokeTextButtonClassname = "text-md font-normal font-sans bg-transparent border-none px-1.5 py-2 hover:drop-shadow text-primary-fg";

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleMenu = useCallback(evt => {
    setAnchorEl(evt.currentTarget);
  }, []);

  const handleChangeLocale = useCallback(locale => {
    dispatch(changeLocale(locale));
    handleClose();
  }, [dispatch, handleClose]);

  const open = Boolean(anchorEl);
  const unselectedClassname = "font-light";
  const selectedClassname = "font-medium";

  return (
    <React.Fragment>
      <SterlingButton className={bespokeTextButtonClassname}
        id="changeLocale"
        fullWidth
        aria-owns={open ? "menu-appbar" : undefined}
        aria-haspopup="true"
        onClick={handleMenu}
      >
        <LanguageIcon className="text-neutral-600" />
        <Hidden xsDown>
          <span className="space-x-2">
            {locales[locale.toLowerCase()]?.shorthand}
          </span>
          <ExpandMoreIcon className="text-neutral-600" />
        </Hidden>
      </SterlingButton>
      <Menu
        disableAutoFocusItem={true}
        id="menu-appbar"
        anchorEl={anchorEl}
        transformOrigin={{
          vertical: -60,
          horizontal: "left",
        }}
        open={open}
        onClose={handleClose}
      >
        {allowedLocales.map((key, index) => {
          return (
            <MenuItem value={key} key={index} onClick={() => handleChangeLocale(key)}>
              <Typography>
                <span className={locale === key ? selectedClassname : unselectedClassname}>
                  {locales[key].localeName}
                </span>
              </Typography>
            </MenuItem>
          )
        })
        }
      </Menu>
    </React.Fragment>
  )
};